import React from 'react';
import styled from 'styled-components';

import ProductCard from '@common/ProductCard';
import { Section, Container } from '@components/global';
import ProductView from '@common/ProductView';

// import { ReactComponent as SquiggleOne } from '@static/squiggles/squiggle-2.svg';
// import { ReactComponent as SquiggleTwo } from '@static/squiggles/squiggle-3.svg';

import { ReactComponent as ProductSqOne } from '@static/squiggles/product-1.svg';
import { ReactComponent as ProductSqTwo } from '@static/squiggles/product-2.svg';
import { ReactComponent as ProductSqThree } from '@static/squiggles/product-3.svg';

import { ReactComponent as ProductLOne } from '@static/squiggles/leaf-1.svg';
import { ReactComponent as ProductLTwo } from '@static/squiggles/leaf-2.svg';
import { ReactComponent as ProductLThree } from '@static/squiggles/leaf-3.svg';

// TODO update product images
import ProductImgSrc from '@static/product-1.png';

const PRODUCT_DATA = [
  {
    title: 'Hard water Shampoo',
    desc:
      'Remove heavy mineral deposits on hair and scalp caused in hard water/ salt-rich water areas. Remove heavy mineral deposits on hair and scalp caused in.',
    subtitle: 'The shampoo helps fight',
    points: [
      'Mineral deposits or Flaking – Greasy, Heavy feeling, Limp Hair',
      'Discoloration/Greying or Loss of Natural Color, Fading',
      'Hair Thinning caused by Blocked Hair Pores',
      'Hair Breakage or Rough and Brittle Hair',
    ],
    knowLink: '/hard-water-shampoo',
    onAddClick: () => console.log('added'),
  },
  {
    title: 'Squalene restorative system',
    desc:
      'Revolutionary natural lipid based conditioning repairs hair damaged by salt, minerals, dryness or color services. Revolutionary natural lipid based conditioning.',
    subtitle: 'The conditioner helps fight',
    points: [
      'Dryness – Optimum Hydration to Prevent Excess Damage',
      'Rough Hair – Improve Hair Elasticity for Softer, Smoother hair',
      'Damaged Hair – Helps Hair Cuticle (outermost layer) Lay Flat',
      'Hair Breakage or Rough and Brittle Hair',
    ],
    knowLink: '/squalene-restorative-system',
    onAddClick: () => console.log('added'),
  },
  {
    title: 'SmoothWave Heat Protection Serum',
    desc:
      'Advanced serum that contains inbuilt natural heat protection based on Baobab Oil. Advanced serum that contains inbuilt natural heat protection based on Baobab Oil.',
    subtitle: 'The serum helps with',
    points: [
      'Hairfall – Softer, Smoother Hair. Less Prone to Breakage',
      'Rough Hair – Improve Hair Elasticity for Softer, Smoother hair',
      'Damaged Hair – Helps Hair Cuticle (outermost layer) Lay Flat',
      'Hair Breakage or Rough and Brittle Hair',
    ],
    knowLink: '/smoothwave-heat-protection-serum',
    onAddClick: () => console.log('added'),
  },
];

const PRODUCT_IMG_DATA = [
  {
    imgSrc: ProductImgSrc,
    caption: 'Fresh feeling hair in no time',
  },
  {
    imgSrc: ProductImgSrc,
    caption: 'Fresh feeling hair in no time',
  },
  {
    imgSrc: ProductImgSrc,
    caption: 'Fresh feeling hair in no time',
  },
];

const Products = () => (
  <Section>
    <Container>
      <Grid>
        <div style={{ position: 'relative' }}>
          <ProductCard {...PRODUCT_DATA[0]} />
        </div>
        <ProductView
          {...PRODUCT_IMG_DATA[0]}
          artFg={<ProductSqOne />}
          artBg={<ProductLOne />}
        />
      </Grid>
      <Grid alternate>
        <ProductView
          {...PRODUCT_IMG_DATA[1]}
          artFg={<ProductSqTwo />}
          artBg={<ProductLTwo />}
          artLeft
        />
        <ProductCard {...PRODUCT_DATA[1]} />
      </Grid>
      <Grid>
        <div style={{ position: 'relative' }}>
          <ProductCard {...PRODUCT_DATA[2]} />
        </div>
        <ProductView
          {...PRODUCT_IMG_DATA[2]}
          artFg={<ProductSqThree />}
          artBg={<ProductLThree />}
        />
      </Grid>
    </Container>
  </Section>
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.alternate ? '3fr 4fr' : '4fr 3fr')};
  grid-column-gap: 12rem;
  grid-row-gap: 6rem;
  margin: 20rem 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr;
    margin: 10rem 0;

    ${props =>
      !props.alternate &&
      `
      > :first-child {
        order: 2;
      }
    `};
  }
`;

// const StyledSquiggleOne = styled(SquiggleOne)`
//   position: absolute;
//   left: -10%;
//   bottom: 36%;
// `;

// const StyledSquiggleTwo = styled(SquiggleTwo)`
//   position: absolute;
//   left: 42%;
//   top: -14%;

//   @media (max-width: ${props => props.theme.screen.md}) {
//     display: none;
//   }
// `;

export default Products;
